<template>
  <div>
      <Layout>
          <div class="container">
              <Row class="hint-img">
                  <img src="../assets/image/img-activate.png"/>
              </Row>
              <Row class="hint">
                  <p>{{$t('message.B_bind_prohint')}}</p>
              </Row>
          </div>
          <div class="split-line"></div>
          <div class="container">
              <Row class="text-email">
                  {{$t('message.B_bind_email')}}
              </Row>
              <Row class="text-cur">
                  <Form ref="form" :model="form" :rules="rule">
                      <FormItem prop="email">
                          <Input type="text" :placeholder="$t('message.inform_input_email')" size="large"
                                 v-model="form.email"></Input>
                      </FormItem>
                  </Form>
              </Row>
              <Row class="text-addr">
                  {{$t('message.B_bind_addr')}}
              </Row>
              <Row class="row_file">
                  <Button class="btn" long type="primary" @click="handleBind('form')">
                      {{$t('message.B_bind_btn')}}
                  </Button>
              </Row>
          </div>
      </Layout>
  </div>
</template>

<script>
  export default {
      name: "B_bind",
      data() {
          return {
              form: {
                  email: ''
              },
              rule: {
                  email: [
                      {required: true, message: 'Please fill in the Email address', trigger: 'blur'},
                      {type: 'email', message: 'Incorrect email format', trigger: 'blur'}
                  ]
              },
              text: {},
              code: ''
          }
      },
      methods: {
          handleBind(name) {
              this.$refs[name].validate((valid) => {
                  if (valid) {
                      let _me = this;
                      let params = {}
                      params.access_key = ACCESS_KEY
                      params.device = this.text.device
                      params.info_code = this.text.info_code
                      params.type = K_TYPE
                      params.activation_code = this.code
                      params.email = this.form.email
                      _me.common.httpPost('anti/fake/bind/email', params)
                          .then(res => {
                              _me.$Message.success({
                                  // title: _me.$t('message.success'),
                                  // content: _me.$t('message.success_content.bind'),
                                  content: _me.$t('message.success'),
                                  duration: 2,
                                  onClose() {
                                      _me.$router.push({
                                          name: 'A_activate',
                                          params: {data: res.data}
                                      });
                                  }
                              });
                          })
                          .catch(err => {
                              _me.$Modal.info({
                                  title: _me.$t('message.error'),
                                  content: err
                              });
                          })
                  } else {
                      this.$Message.error('Fail');
                  }
              })
          },
          getText() {
              let _me = this;
              _me.text = _me.$route.params.data;
              if (_me.text == undefined) {
                  let list = sessionStorage.getItem("text");
                  _me.text = JSON.parse(list);
              } else {
                  sessionStorage.setItem("text", JSON.stringify(_me.text));
              }
          }
      },
      created() {
          // this.text = this.$route.params.data;
          this.getText();
          this.code = this.$route.params.code;
      }
  }
</script>

<style scoped>
  .hint {
      margin-bottom: 0.92rem;
  }
  
  .text-email {
      font-size: 0.34rem;
      color: #000000;
      text-align: left;
      margin-bottom: 0.46rem;
  }
  
  .text-addr {
      font-size: 0.26rem;
      color: #777777;
      text-align: left;
      /*margin-top: 0.14rem;*/
  }
  
  .row_file {
      margin-top: 1.2rem;
  }
  
  .split-line {
      margin: 0;
      margin-bottom: 0.66rem;
  }
</style>
